import { TranslationKey } from './../translation/TranslationKey';

import { t } from '../translation/Translator';

export enum StockLocationAggregateType {
  all = 'all',
  allOf = 'allOf',
  any = 'any',
  anyOf = 'anyOf',
}

export function stockLocationAggregateTypeToString(type: StockLocationAggregateType): string {
  switch (type) {
    case StockLocationAggregateType.all:
      return t(TranslationKey.all).singular.label;
    case StockLocationAggregateType.allOf:
      return t(TranslationKey.allOf).singular.label;
    case StockLocationAggregateType.any:
      return t(TranslationKey.any).singular.label;
    case StockLocationAggregateType.anyOf:
      return t(TranslationKey.anyOf).singular.label;
  }
}
